import { url, tokenRef } from "api";

// Oversight entries and their log (owner brief 2026-10-11 T39-T42). The
// entry is locked: the writes below are refused (403) for anyone but a super
// admin, and the panel only offers them when the server says canEdit.
const headers = () => {
  const h = { "Content-Type": "application/json" };
  const token = localStorage.getItem(tokenRef);
  if (token) h.Authorization = `Bearer ${token}`;
  return h;
};

const call = async (method, path, body) => {
  const response = await fetch(`${url}${path}`, {
    method,
    headers: headers(),
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.err || "Request failed");
    error.status = response.status;
    throw error;
  }
  return data;
};

const read = (path) => call("GET", path);

export const getOversight = (projectId) => read(`/projects/${projectId}/oversight`);
export const getOversightLog = (projectId, { limit = 200, before } = {}) =>
  read(`/projects/${projectId}/oversight/log?limit=${limit}${before ? `&before=${encodeURIComponent(before)}` : ""}`);

// Super admin only (the server refuses everyone else).
export const getOversightCompanies = (projectId) => read(`/projects/${projectId}/oversight/companies`);
export const createOversight = (projectId, body) => call("POST", `/projects/${projectId}/oversight`, body);
export const updateOversight = (projectId, entryId, body) => call("PUT", `/projects/${projectId}/oversight/${entryId}`, body);
export const deleteOversight = (projectId, entryId) => call("DELETE", `/projects/${projectId}/oversight/${entryId}`);
